import React, { useEffect } from 'react';

const Modal = ({ isOpen, onClose, title, content, icon }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6">
            {/* Backdrop */}
            <div 
                className="absolute inset-0 bg-black/20 animate-fadeIn"
                onClick={onClose}
            />
            
            {/* Modal */}
            <div className="relative bg-white rounded-2xl sm:rounded-3xl shadow-2xl max-w-7xl w-full max-w-[90vw] max-h-[95vh] sm:max-h-[90vh] overflow-hidden transform transition-all duration-500 animate-slideIn">
                {/* Header */}
                <div className="bg-white p-8 sm:p-10 lg:p-12 pb-2 sm:pb-4 relative">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center">
                            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900">{title}</h2>
                        </div>
                        <button
                            onClick={onClose}
                            className="text-black hover:text-gray-600 transition-all duration-300 p-2 hover:scale-110 text-3xl font-bold"
                            aria-label="Schließen"
                        >
                            ✕
                        </button>
                    </div>
                </div>
                
                {/* Content */}
                <div className="p-8 sm:p-10 lg:p-12 pt-2 sm:pt-4 overflow-y-auto max-h-[calc(95vh-160px)] sm:max-h-[calc(90vh-180px)] bg-white">
                    <div className="space-y-3 sm:space-y-4 text-gray-700 leading-relaxed">
                        {content.map((paragraph, index) => (
                            <div key={index} className="text-lg sm:text-xl leading-8 sm:leading-9 text-gray-800">
                                {typeof paragraph === 'string' ? (
                                    <p>{paragraph}</p>
                                ) : (
                                    paragraph
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;